import { Flex, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { LuLandmark } from 'react-icons/lu';
import { SidebarNav } from './SidebarNav';

export function Sidebar() {
  return (
    <Flex
      as="aside"
      direction="column"
      display={{ base: 'none', md: 'flex' }}
      w="244px"
      borderRightWidth="1px"
      borderColor="border"
      bg="bg.surface"
      py="4"
      px="3"
      gap="4"
      position="sticky"
      top={0}
      h="100dvh"
      overflowY="auto"
    >
      <HStack px="2" gap="2">
        <Flex
          w="9"
          h="9"
          align="center"
          justify="center"
          rounded="lg"
          bg="brand.500"
          color="white"
          shadow="sm"
        >
          <Icon as={LuLandmark} boxSize="5" />
        </Flex>
        <VStack align="start" gap="0">
          <Text fontWeight="700" lineHeight="1.1" fontSize="md">
            CrediFacilGT
          </Text>
          <Text fontSize="xs" color="fg.muted">
            Lotificadora
          </Text>
        </VStack>
      </HStack>

      <SidebarNav />
    </Flex>
  );
}
